import { render, staticRenderFns } from "./storageStatus.vue?vue&type=template&id=196ba8c6&scoped=true"
import script from "./storageStatus.vue?vue&type=script&lang=js"
export * from "./storageStatus.vue?vue&type=script&lang=js"
import style0 from "./storageStatus.vue?vue&type=style&index=0&id=196ba8c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196ba8c6",
  null
  
)

export default component.exports